/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const updateTeamRoleRequestSchema = z.object({
  name: z.string().nullish(),
});
